import React from "react";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
import "./Shipping.css";
const Shipping = () => {
    return (
        <>
            <div class="tf-page-title">
                <div class="row">
                    <div class="col-12">
                        <div class="heading text-center ">
                            <h4 className='breadcrumbtitle'>Shipping Policy</h4>
                            <div className=' breadcrumb'>
                                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                                <h6>Shipping Policy</h6></div>
                        </div>
                    </div>
                </div>

            </div>
            <div style={{maxWidth:"80%",position:"relative",marginLeft:"auto",marginRight:"auto",fontFamily:"Poppins, serif"}}>

            <pre>
                At ROYAL HOOD we are committed to delivering your orders promptly and efficiently. This Shipping Policy outlines the terms and conditions governing the shipment and delivery of your purchases.
                <br/>
                ________________________________________<br/>
                1. Shipping Locations<br/>
                We currently ship to locations within India .<br/>
                ________________________________________<br/>
                2. Shipping Charges<br/>
                •	Domestic Shipping: Will Display while CheckOut.<br/>
                ________________________________________<br/>
                3. Delivery Timeline<br/>
                •	Processing Time: Orders are typically processed within 1-2  business days after payment confirmation.<br/>
                •	Estimated Delivery Time:<br/>
                o	Metro Cities: [1-2 days]<br/>
                o	Non-Metro Cities: 2-4 days]<br/>
                Note: Delivery timelines are approximate and may vary due to unforeseen circumstances like natural disasters, strikes, or logistical delays.
                <br/>________________________________________<br/>
                4. Delivery Attempts<br/>
                •	Our delivery partner will attempt 3-4 deliveries before returning the package to us.
                <br/>•	If the delivery fails due to incorrect address or unavailability, additional charges may apply for re-shipping.
                <br/>________________________________________
                <br/>5. Packaging
                <br/>We ensure secure packaging of all orders to protect them during transit. If you notice any damage to the package upon delivery, please refuse to accept it ,<br/> take photograph or video proof and inform us immediately.
                <br/>________________________________________
                <br/>6. Delayed or Missed Deliveries
                <br/>While we strive to deliver within the estimated timeframe, delays may occur due to external factors. If your order is delayed, please contact us at support@royalhood.in, and we will assist you.
                <br/>________________________________________
                <br/>7. Undeliverable Packages
                <br/>Orders may be deemed undeliverable due to:
                <br/>•	Incorrect or incomplete address.
                <br/>•	Customer unavailability.
                <br/>•	Restricted shipping zone.
                <br/>In such cases, the order will be cancelled, and a refund (excluding shipping fees) will be processed as per our Refund Policy.
                <br/>________________________________________
                <br/>8. International Shipping
                <br/>•	Customs clearance is the responsibility of the customer.
                <br/>•	Any additional duties, taxes, or fees levied by the destination country will be borne by the customer.
                <br/>•	Delays caused by customs are beyond our control.
                <br/>________________________________________
                <br/>9. Changes to Shipping Address
                <br/>•	Changes to the shipping address can be requested within 24 hours of placing the order.
                <br/>•	Contact us at support@royalhood.in for assistance.
                <br/>________________________________________
                <br/>
                <br/>10. Contact Us
                <br/>For shipping-related inquiries or issues, please reach out to us:
                <br/>Email: support@royalhood.in
                <br/>Phone: 9620072626<br/>
                </pre>
            </div>
        </>
    );
};
export default Shipping;